import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router/router'
import store from './store'
import 'lib-flexible/flexible.js'
import VueResource from 'vue-resource'
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false

Vue.config.devtools = true

Vue.use(VueResource)
Vue.use(Vuex)

Vue.use(VueLazyload, {
    preLoad: 1.3, //距离当前dom距离页面底部的高度
    error: 'https://pic1.zhen.com/appimg/wx/my/touxiang.png', //加载失败显示的图片
    loading: 'https://pic1.zhen.com/appimg/wx/icon_default.png', //加载中显示的图片
    attempt: 1 // 图片加载失败，最多重试的次数
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        var til = to.meta.title
        if ('noshow' == til) {
            til = ''
        }
        document.title = til
        // 华为有款手机会报错
        try {
            // 改变标题页的方法。 window.adObject是安卓方法
            var pdIphone = /ipad|iphone/i.test(navigator.userAgent) ? 'ios' : 'android'
            if (pdIphone == 'ios') {
                // console.log("ios")
                try {
                    window.webkit.messageHandlers.changeAppTitle &&
                        window.webkit.messageHandlers.changeAppTitle.postMessage([til])
                } catch {
                    window.changeAppTitle && window.changeAppTitle(til)
                }
            } else {
                // console.log("Android")
                window.adObject && window.adObject.changeAppTitle && window.adObject.changeAppTitle(til)
            }
        } catch (err) {
            console.log(err)
        }
    }
    next()
})

// 安卓会默认调用该方法，没有该方法控制台会报错，，，阻止进程。。。。。。。。。。。。。。。。（=.=）
window.JShare = function() {}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
